import { getInstanceField } from './useGetInstanceField'

export const useI18n = () => {
  const i18n = getInstanceField('$i18n')

  return i18n
}
